import {AfterViewInit, Component, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {AuthSessionApiService, Organization} from '@npck/auth-frontend-api';
import {OauthRedirectErrorCode} from '@npck/errors-api';
import {BusinessErrorCode, RouterService, rxSpinner, Spinner, toBusinessOrNull} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {OauthService} from '../../domain/oauth.service';
import {Path} from '../../path';

@Component({
    templateUrl: 'bin.component.html',
    styleUrls: ['bin.component.scss'],
    standalone: false
})
export class BinComponent implements AfterViewInit {
    @ViewChildren('orgCards', {read: ElementRef}) orgCards: QueryList<ElementRef>;

    error: BusinessErrorCode;
    organizations: Array<Organization>;
    protected readonly Spinner = Spinner;

    constructor(
        private routerService: RouterService,
        private authHolderService: AuthHolderService,
        private authSessionApiService: AuthSessionApiService,
        private oauthService: OauthService,
    ) {
        this.organizations = authHolderService.organizations;
        if (this.organizations.length == 1) {
            this.navigateToAuthorize(this.organizations[0].bin);
        }
    }

    ngAfterViewInit(): void {
        this.orgCards.first?.nativeElement?.focus();
    }

    navigateToAuthorize(bin: string): void {
        this.authSessionApiService.authSessionSelectOrganizationBin({bin})
            .pipe(rxSpinner('selectBin'))
            .subscribe({
                next: response => {
                    this.authHolderService.storeOrganization(this.organizations.filter(it => it.bin === bin)[0]);
                    this.authHolderService.storeAuthSessionToken(response.token);
                    this.routerService.navigate(Path.OAUTH_AUTHORIZE);
                },
                error: error => {
                    const businessError = toBusinessOrNull(error);
                    if (businessError) {
                        if (businessError.error === BusinessErrorCode.GOV_SERVICE_UNAVAILABLE) {
                            this.oauthService.handleOauthErrorAndRedirect(
                                OauthRedirectErrorCode.gov_service_unavailable, businessError.requestId);
                        } else {
                            this.error = businessError.error;
                        }
                    } else {
                        throw error;
                    }
                },
            });
    }

    onClose(): void {
        this.error = null;
    }
}
